import React from 'react'

const CustomSvgIcon = ({
  svgString,
  width = '1.5rem',
  height = '1.5rem',
  fill = 'currentColor',
  svgClass = null,
  style = {},
  onClick = undefined,
}) => {
  let processedSvg = svgString
    .replace(/fill="(?!none)[^"]*"/g, 'fill="currentColor"')
    .replace(/stroke="(?!none)[^"]*"/g, 'stroke="currentColor"')
    .replace(/width="[^"]*"/g, '')
    .replace(/height="[^"]*"/g, '')
    .replace(/<svg([^>]+)>/, '<svg$1 width="100%" height="100%" preserveAspectRatio="xMidYMid meet">')
    .replace('<svg', '<svg style="display:block;margin:0;padding:0;"')
  if (svgClass) {
    processedSvg = processedSvg.replace(
      /<svg([^>]*)>/,
      (_, attrs) =>
        `<svg${attrs} width="100%" height="100%" preserveAspectRatio="xMidYMid meet" class="${svgClass.trim()}">`,
    )

    processedSvg = processedSvg.replace('<svg', '<svg style="display:block;margin:0;padding:0;"')
  }

  const handleClick = () => {
    if (!onClick) return
    onClick()
  }

  return (
    <div
      onClick={handleClick}
      style={{
        width,
        height,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: fill,
        ...style,
      }}
      dangerouslySetInnerHTML={{ __html: processedSvg }}
    />
  )
}

export default CustomSvgIcon
